export default __webpack_public_path__ + "static/media/evangelico.09ad7a52.png";